import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/create_sign_wall.png'


const _withScopeId = n => (_pushScopeId("data-v-0b732895"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "back" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_4 = { class: "main" }
const _hoisted_5 = { class: "main_blank" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main_blank_title" }, "活动名称：", -1))
const _hoisted_7 = { class: "main_blank" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main_blank_title" }, "活动背景：", -1))
const _hoisted_9 = { class: "main_blank" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main_blank_title" }, "签到二维码：", -1))
const _hoisted_11 = { class: "main_blank_sw" }
const _hoisted_12 = { class: "main_blank" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main_blank_title" }, "签到样式：", -1))
const _hoisted_14 = { class: "main_blank_rg" }

import { reactive, ref } from 'vue';
import CUpload from '@/components/CUpload.vue';
import { message, Radio, Checkbox } from 'ant-design-vue';
import http from '@/api/application';
import router from '@/router';
import { useRoute } from 'vue-router';
import { FileInfo } from './sign';
import { RollbackOutlined } from '@ant-design/icons-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateSignWall',
  setup(__props) {

const route = useRoute();
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aCheckboxGroup = Checkbox.Group;

// 上传图片
const fileList = ref();
const handleChange = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    form.image = info.file?.response?.data.url;
  }
  if (info.file.status === 'uploading') {
    form.loading = true;
    return;
  } else {
    form.loading = false;
  }
  if (info.file.status === 'error') {
    message.error('上传失败');
  }
};
// 清空图片
const imageDel = () => {
  form.image = '';
};

const form = reactive({
  name: '',
  image: '',
  loading: false,
  checked: true,
  seat: 0,
  wanner: ['表格'],
});

const plainOptions = ['表格', '球球', '螺旋', '格子']; //0.表格，1.球球，2.螺旋，3.格子

// 获取活动信息
const getActivedInfo = () => {
  http
    .get_activity_info({ params: { id: route.query.id } })
    .then((res) => {
      const resData = res.data.data;
      form.image = resData.background_image;
      form.name = resData.name;
      form.checked = resData.qr_code_status ? true : false;
      form.seat = resData.position;
      form.wanner = resData.sign_style.split('').map((e: any) => plainOptions[e]);
    })
    .catch((err) => message.error(err.data.error));
};
if (route.query.id) {
  getActivedInfo();
}

// 新建活动
const preservation = () => {
  const arr = form.wanner.reduce((pre: any, cur) => {
    if (cur === '表格') pre.push(0);
    if (cur === '球球') pre.push(1);
    if (cur === '螺旋') pre.push(2);
    if (cur === '格子') pre.push(3);
    return pre;
  }, []);
  const data = {
    name: form.name,
    background_image: form.image,
    qr_code_status: form.checked ? 1 : 0,
    position: form.seat,
    sign_style: arr.join(),
  };

  if (route.query.id) {
    editActivity(data);
  } else {
    http
      .create_activity(data)
      .then((res) => {
        message.success(res.data.message);
        router.push('/application/signWall');
      })
      .catch((err) => message.error(err.data.error));
  }
};

// 修改活动
const editActivity = (data: any) => {
  data.id = route.query.id;
  http
    .edit_activity(data)
    .then((res) => {
      message.success(res.data.message);
      router.push('/application/signWall');
    })
    .catch((err) => message.error(err.data.error));
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/application/signWall')))
      }, {
        icon: _withCtx(() => [
          _createVNode(_unref(RollbackOutlined))
        ]),
        default: _withCtx(() => [
          _createTextVNode("返回列表 ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_a_input, {
            value: form.name,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.name) = $event)),
            placeholder: "请输入活动名称",
            class: "main_blank_in"
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(CUpload, {
            "file-list": fileList.value,
            "handle-change": handleChange,
            loading: form.loading,
            "image-name": form.image,
            "click-stop": imageDel,
            class: "main_blank_upload"
          }, null, 8, ["file-list", "loading", "image-name"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_a_switch, {
                checked: form.checked,
                "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((form.checked) = $event))
              }, null, 8, ["checked"])
            ]),
            _createVNode(_unref(aRadioGroup), {
              value: form.seat,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.seat) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(aRadio), { value: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode("左上")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(aRadio), { value: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode("右上")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(aRadio), { value: 2 }, {
                  default: _withCtx(() => [
                    _createTextVNode("左下")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(aRadio), { value: 3 }, {
                  default: _withCtx(() => [
                    _createTextVNode("右下")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(aCheckboxGroup), {
              value: form.wanner,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.wanner) = $event)),
              name: "checkboxgroup",
              options: plainOptions
            }, null, 8, ["value"])
          ])
        ]),
        _createVNode(_component_a_button, {
          type: "primary",
          class: "btn_save",
          onClick: preservation
        }, {
          default: _withCtx(() => [
            _createTextVNode("保存")
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})